import { Button, Link, Paper, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { ClassroomInfo } from "../../../redux/classroom/classroomSlice";
import { getBackendTypstUrl } from "../../../redux/common";
import { SchoolInfo } from "../../../redux/school/schoolSlice";

interface ClassroomInviteReportProps {
    school: SchoolInfo;
    classroom: ClassroomInfo;
}

const ClassroomInviteReport = (props: ClassroomInviteReportProps) => {
    const dispatch = useDispatch();
    const { school, classroom } = props;

    return (
        <center>
            <Paper style={{ padding: 20, margin: 20, minWidth: 300, maxWidth: 800, boxSizing: "border-box" }}>
                <Typography style={{ marginTop: 10 }}>
                    Este relatório gera um PDF com um convite por página, contendo o código do convite e o nome do aluno, além de informações sobre o aplicativo, que pode ser impresso para ser enviado às famílias.
                </Typography><br />
                {/* <Button variant="contained" color="primary" onClick={() => setGenerate(true)}>Gerar relatório</Button> */}
                <Link href={`${getBackendTypstUrl()}/api/invite/students/classroom/${classroom.id}`} 
                    target="_blank" rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}>
                    <Button variant="contained" color="primary">Gerar relatório</Button>
                </Link>
            </Paper>
        </center>
    );
};

export default ClassroomInviteReport;